export default function BrandBar() {
  const linkStyle = {
    color: 'rgba(255,255,255,0.6)', fontSize: '9px', letterSpacing: '0.15em',
    textTransform: 'uppercase', textDecoration: 'none', padding: '0 12px',
    borderRight: '1px solid rgba(255,255,255,0.08)', lineHeight: '32px',
  };

  return (
    <div style={{
      height: '32px',
      background: '#0a0907',
      borderBottom: '1px solid rgba(198,169,111,0.06)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 60,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '8px',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <a href="https://pixally.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>Pixally</a>
      <a href="https://uncutgems.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>Uncut Gems</a>
      <span style={{
        color: '#c6a96f', fontSize: '9px', letterSpacing: '0.15em',
        textTransform: 'uppercase', padding: '0 12px', lineHeight: '32px',
        fontWeight: 'bold', background: 'rgba(198,169,111,0.06)',
      }}>GemVault</span>
    </div>
  );
}
